export default __webpack_public_path__ + "static/media/Five.4295ac62.svg";